import { font } from '@approvalmax/ui';
import styled from 'styled-components';

export const AmountRow = styled.div`
    display: flex;
    flex-flow: column;
`;

export const AmountFieldRow = styled.div`
    display: flex;
    align-items: center;

    & > :nth-child(odd) {
        ${font(13, '#1d2e39')};
        margin-right: 10px;
    }

    & > :nth-child(3) {
        margin-left: 10px;
    }

    & > :nth-child(even) {
        width: 140px;
    }
`;

export const AmountRowNote = styled.div`
    margin-top: 5px;
    ${font(12, '#5e5c5c')}
`;
